import OnboardingPage from "@/pages/Onboarding/OnboardingPage";
import { handleOnboardingRedirect } from "@/utils/routeGuards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/companies/$company_id/onboarding/")({
  beforeLoad: async ({ params }: { params: { company_id: string } }) => {
    // Handle onboarding redirect based on company status:
    // - If onboarding complete → redirect to summary page (handles processing, failed, ready)
    // - If onboarding not complete → allow access to continue
    await handleOnboardingRedirect(params.company_id);
  },
  component: OnboardingPage,
});
